import React from 'react';
import TextFieldAtom from '../../../../components/atoms/text-field/text-field';
import { Col, Row } from 'react-bootstrap';

const InfoRow = ({
    label,
    value,
    isNegative = false,
    isBold = false,
    isTotal = false,
    suffix = "",
    isEditable = false,
    name = "",
    onChange = () => { },
    equalColumns = false,
}) => {
    // Function to determine if a value should be treated as non-existent
    const exists = (val) => val !== undefined && val !== null && val !== '';

    // Smart layout based on content availability
    const hasLabel = exists(label);
    const hasValue = exists(value);

    // Determine column sizes based on the equalColumns prop
    const labelColSize = equalColumns ? 6 : 8;
    const valueColSize = equalColumns ? 6 : 4;

    // Format value if it's a number
    const formattedValue = typeof value === 'number'
        ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
        : value;

    const valueClass = `
        text-end 
        ${isNegative ? 'text-danger' : ''} 
        ${isBold ? 'fw-bold' : ''}
        ${isTotal ? 'border-top border-dark pt-2' : ''}
    `.trim();

    // Render value content (editable or static)
    const renderValue = () => {
        if (isEditable) {
            return (
                <TextFieldAtom
                    name={name}
                    value={value}
                    onChange={onChange}
                    className={typeof value === 'number' ? "text-end" : ""}
                    suffix={suffix}
                />
            );
        }

        return (
            <>
                {/* {isNegative && value !== 0 && '-'} */}
                {formattedValue}
                {formattedValue && formattedValue !== '-' && suffix ? ` ${suffix}` : ''}
            </>
        );
    };

    // If neither label nor value exists, don't render anything
    if (!hasLabel && !hasValue) {
        return null;
    }

    return (
        <Row className="mb-1 align-items-center">
            {hasLabel && hasValue ? (
                // Both label and value exist - use configurable layout
                <>
                    <Col md={labelColSize}>{label}</Col>
                    <Col md={valueColSize} className={valueClass}>
                        {renderValue()}
                    </Col>
                </>
            ) : hasLabel ? (
                // Only label exists - use full width
                <Col md={12}>{label}</Col>
            ) : (
                // Only value exists - use full width but keep alignment
                <Col md={12} className={valueClass}>
                    {renderValue()}
                </Col>
            )}
        </Row>
    );
};

export default InfoRow;
